document.addEventListener("DOMContentLoaded", function () {
  const sliders = document.querySelectorAll(".enable-horizontal-scroll-left-mouse");

  sliders.forEach((slider) => {
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener("mousedown", (e) => {
      isDown = true;
      slider.classList.add("scrolling");
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener("mouseleave", () => {
      isDown = false;
      slider.classList.remove("scrolling");
    });

    slider.addEventListener("mouseup", () => {
      isDown = false;
      slider.classList.remove("scrolling");
    });

    slider.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 2.5; // Speed factor
      slider.scrollLeft = scrollLeft - walk;
    });
  });
});
